import FeedbackIcon from "@ch/assets/icons/pack/FeedbackIcon.tsx";
import StepsIcon from "@ch/assets/icons/pack/Steps.tsx";
import StressIcon from "@ch/assets/icons/pack/Stress.tsx";
import RespirationIcon from "@ch/assets/icons/pack/Respiration.tsx";
import MoonIcon from "@ch/assets/icons/pack/MoonIcon.tsx";
import BloodOxygenIcon from "@ch/assets/icons/pack/BloodOxygenIcon.tsx";
import CoachIcon from "@ch/assets/icons/pack/CoachIcon.tsx";
import TwoFaIcon from "./pack/2faIcon";
import ArrowFatLinesUp from "./pack/ArrowFatLinesUp";
import ArrowLeftIcon from "./pack/ArrowLeft";
import BackArrowIcon from "./pack/BackArrowIcon";
import Bell3Icon from "./pack/Bell3Icon";
import Bell2Icon from "./pack/BellI2con";
import BellIcon from "./pack/BellIcon";
import BiometricIcon from "./pack/BiometricIcon";
import BloodBagIcon from "./pack/BloodBagIcon";
import BloodDropIcon from "./pack/BloodDropIcon";
import CalendarIcon from "./pack/CalendarIcon";
import CalendarTickIcon from "./pack/CalendarTickIcon";
import CategoryIcon from "./pack/CategoryIcon";
import Chat2Icon from "./pack/Chat2Icon";
import Chat3Icon from "./pack/Chat3Icon";
import ChatIcon from "./pack/ChatIcon";
import CheckMarkIcon from "./pack/CheckMarkIcon";
import ChevronDownIcon from "./pack/ChevronDownIcon";
import ChevronLeftFilledIcon from "./pack/ChevronLeftFilledIcon";
import ChevronLeftIcon from "./pack/ChevronLeftIcon";
import ChevronRightFilledIcon from "./pack/ChevronRightFilledIcon";
import ChevronRightIcon from "./pack/ChevronRightIcon";
import ChevronRightTwo from "./pack/ChevronRightIcon2";
import CholesterolIcon from "./pack/CholesterolIcon";
import ClockIcon from "./pack/ClockIcon";
import DangerIcon from "./pack/DangerIcon";
import DeleteIcon from "./pack/DeleteIcon";
import DownloadIcon from "./pack/DownloadIcon";
import EditIcon from "./pack/EditIcon";
import EmailAtSymbol from "./pack/EmailAtSymbolIcon";
import EmojiIcon from "./pack/EmojiIcon";
import ExerciseIcon from "./pack/ExerciseIcon";
import Eye2CloseIcon from "./pack/Eye2Close";
import Eye2OpenIcon from "./pack/Eye2Open";
import EyeOpenIcon from "./pack/EyeOpenIcon";
import FemaleIcon from "./pack/FemaleIcon";
import Filter from "./pack/Filter";
import FirstAidKitIcon from "./pack/FirstAidKitIcon";
import FlipNoteIcon from "./pack/FlipNoteIcon";
import FolderIcon from "./pack/FolderIcon";
import FootprintsIcon from "./pack/FootprintsIcon";
import ForumsIcon from "./pack/ForumsIcon";
import ForwardArrowIcon from "./pack/FowardArrowIcon";
import HealthDiaryIcon from "./pack/HealthDiaryIcon";
import HealthPassportIcon from "./pack/HealthPassportIcon";
import HeartbeatIcon from "./pack/HeartbeatIcon";
import HistoryOutlineIcon from "./pack/HistoryOutlineIcon";
import HospitalIcon from "./pack/HospitalIcon";
import InfoCircle from "./pack/InfoCircle";
import KemChatIcon from "./pack/KemChatIcon";
import LocationIcon from "./pack/LocationIcon";
import LoginIcon from "./pack/LoginIcon";
import LogoIcon from "./pack/LogoIcon";
import MaleIcon from "./pack/MaleIcon";
import MenuIcon from "./pack/MenuIcon";
import MicroscopeIcon from "./pack/MicroscopeIcon";
import MindfulnessIcon from "./pack/MindfulnessIcon";
import MoreOptionsIcon from "./pack/MoreOptions";
import NavigationIcon from "./pack/NavigationIcon";
import NoteIcon from "./pack/NoteIcon";
import NotificationIcon from "./pack/NotificationIcon";
import OutdoorBikingIcon from "./pack/OutdoorBikingIcon";
import PaperClipIcon from "./pack/PaperClipIcon";
import PasswordEditIcon from "./pack/PasswordEditIcon";
import PaymentHistoryIcon from "./pack/PaymentHistoryIcon";
import PersonArmSpreadIcon from "./pack/PersonArmSpreadIcon";
import PersonCardIcon from "./pack/PersonCardIcon";
import PersonIcon from "./pack/PersonIcon";
import PillIcon from "./pack/PillIcon";
import PlusIcon from "./pack/PlusIcon";
import PregnancyOutlineIcon from "./pack/PregnancyOutlineIcon";
import PrescriptionIcon from "./pack/PrescriptionIcon";
import RadarIcon from "./pack/RadarIcon";
import ReferralsIcon from "./pack/ReferralsIcon";
import ReadIcon from "./pack/ReadIcon";
import RunningIcon from "./pack/RunningIcon";
import SearchIcon from "./pack/SearchIcon";
import SecurityIcon from "./pack/SecurityIcon";
import SettingsIcon from "./pack/SettingsIcon";
import SettingsIconTwo from "./pack/SettingsIconTwo";
import ShareIcon from "./pack/ShareIcon";
import SparkleIcon from "./pack/Sparkle";
import StatusIndicatorIcon from "./pack/StatusIndicatorIcon";
import StethoscopeIcon from "./pack/StethoscopeIcon";
import SubscriptionIcon from "./pack/SubscriptionIcon";
import TabIcon from "./pack/TabIcon";
import TargetIcon from "./pack/TargetIcon";
import TeamIcon from "./pack/TeamIcon";
import TemperatureIcon from "./pack/TemperatureIcon";
import TestTubeIcon from "./pack/TestTubeIcon";
import TickCircleIcon from "./pack/TickCircleIcon";
import UserCheckIcon from "./pack/UserCheckIcon";
import UserIcon from "./pack/UserIcon";
import UserProfile from "./pack/UserProfileIcon";
import WaistCircumferenceIcon from "./pack/WaistCircumferenceIcon";
import Weight2Icon from "./pack/Weight2Icon";
import WeightIcon from "./pack/WeightIcon";
import WhatsappIcon from "./pack/WhatsappIcon";
import CloseIcon from "./pack/CloseIcon";
import AlertCircleIcon from "./pack/AlertCircle";
import EnvelopeIcon from "./pack/Envelope";
import CheckMarkIcon2 from "./pack/CheckMarkIcon2";
import ThumbsUpIcon from "./pack/ThumbsUp";
import ThumbsDownIcon from "./pack/ThumbsDown";
import PinIcon from "./pack/PinIcon";
import SendIcon from "./pack/SendIcon";
import PlayIcon from "./pack/PlayIcon";
import PauseIcon from "./pack/PauseIcon";
import MicIcon from "./pack/MicIcon";
import WearableIcon from "./pack/WearableIcon";
import WarningIcon from "./pack/WarningIcon";

const iconPack = {
  heartbeat: HeartbeatIcon,
  pill: PillIcon,
  "eye-open": EyeOpenIcon,
  footprints: FootprintsIcon,
  hospital: HospitalIcon,
  "first-aid-kit": FirstAidKitIcon,
  feedback: FeedbackIcon,
  prescription: PrescriptionIcon,
  "test-tube": TestTubeIcon,
  logo: LogoIcon,
  category: CategoryIcon,
  "calendar-tick": CalendarTickIcon,
  chat: ChatIcon,
  coach: CoachIcon,
  "chat-3": Chat3Icon,
  "kem-chat": KemChatIcon,
  navigation: NavigationIcon,
  bell: BellIcon,
  subscription: SubscriptionIcon,
  radar: RadarIcon,
  referrals: ReferralsIcon,
  menu: MenuIcon,
  login: LoginIcon,
  search: SearchIcon,
  calendar: CalendarIcon,
  settings: SettingsIcon,
  user: UserIcon,
  plus: PlusIcon,
  edit: EditIcon,
  "health-passport": HealthPassportIcon,
  "chevron-left-filled": ChevronLeftFilledIcon,
  "chevron-right-filled": ChevronRightFilledIcon,
  "chevron-right": ChevronRightIcon,
  sparkle: SparkleIcon,
  tab: TabIcon,
  "tick-circle": TickCircleIcon,
  share: ShareIcon,
  download: DownloadIcon,
  folder: FolderIcon,
  "status-indicator": StatusIndicatorIcon,
  weight: WeightIcon,
  "blood-bag": BloodBagIcon,
  "blood-drop": BloodDropIcon,
  cholesterol: CholesterolIcon,
  exercise: ExerciseIcon,
  running: RunningIcon,
  "outdoor-biking": OutdoorBikingIcon,
  stethoscope: StethoscopeIcon,
  "waist-circumference": WaistCircumferenceIcon,
  "pregnancy-outline": PregnancyOutlineIcon,
  "history-outline": HistoryOutlineIcon,
  target: TargetIcon,
  "bell-2": Bell2Icon,
  "bell-3": Bell3Icon,
  "eye-2-Open": Eye2OpenIcon,
  "eye-2-Close": Eye2CloseIcon,
  "info-circle": InfoCircle,
  location: LocationIcon,
  "back-arrow": BackArrowIcon,
  "arrow-left": ArrowLeftIcon,
  mindfulness: MindfulnessIcon,
  note: NoteIcon,
  clock: ClockIcon,
  whatsapp: WhatsappIcon,
  "forward-arrow": ForwardArrowIcon,
  male: MaleIcon,
  female: FemaleIcon,
  "user-check": UserCheckIcon,
  "health-diary": HealthDiaryIcon,
  "flip-note": FlipNoteIcon,
  "mark-read": ReadIcon,
  "more-options": MoreOptionsIcon,
  emoji: EmojiIcon,
  "paper-clip": PaperClipIcon,
  "two-fa": TwoFaIcon,
  "email-at-symbol": EmailAtSymbol,
  envelope: EnvelopeIcon,
  "chevron-right-2": ChevronRightTwo,
  "chevron-left": ChevronLeftIcon,
  biometric: BiometricIcon,
  "password-edit": PasswordEditIcon,
  forum: ForumsIcon,
  "payment-history": PaymentHistoryIcon,
  "settings-two": SettingsIconTwo,
  security: SecurityIcon,
  "user-profile": UserProfile,
  "chat-2": Chat2Icon,
  "chevron-down": ChevronDownIcon,
  "weight-2": Weight2Icon,
  person: PersonIcon,
  "person-arm-spread": PersonArmSpreadIcon,
  team: TeamIcon,
  "person-card": PersonCardIcon,
  microscope: MicroscopeIcon,
  "arrow-fat-lines-up": ArrowFatLinesUp,
  filter: Filter,
  delete: DeleteIcon,
  danger: DangerIcon,
  temperature: TemperatureIcon,
  "check-mark": CheckMarkIcon,
  "check-mark-2": CheckMarkIcon2,
  notification: NotificationIcon,
  close: CloseIcon,
  "alert-circle": AlertCircleIcon,
  "thumbs-up": ThumbsUpIcon,
  "thumbs-down": ThumbsDownIcon,
  pin: PinIcon,
  send: SendIcon,
  play: PlayIcon,
  pause: PauseIcon,
  microphone: MicIcon,
  steps: StepsIcon,
  stress: StressIcon,
  respiration: RespirationIcon,
  moon: MoonIcon,
  bloodOxygen: BloodOxygenIcon,
  wearable: WearableIcon,
  warning: WarningIcon,
};

export { iconPack };

export type TIconPack = keyof typeof iconPack;

export const iconNames = Object.keys(iconPack) as TIconPack[];
